import React from 'react';
import styled from "styled-components";
import play from "assets/play.png";
import home from "assets/home.png";
import Title from './Title';
import { motion } from "framer-motion";
import { useScroll } from "./useScroll";
import { blogsAnimation } from "animation";

function Blog() {
  const [element, controls] = useScroll();
  const blogsData = [
    {
      title: "NZHERALD",
      type: "Hair",
      description: "Summer strands stressing you out? Here’s how to get your hair looking and feeling healthy again",
      link: "https://www.nzherald.co.nz/viva/beauty/how-to-repair-two-weeks-worth-of-hair-damage-from-your-summer-holidays/6XBCLP7P3JC7TMSPTSUVBIWO7E/"
    },
    {
      title: "Woman Magazine NZ",
      type: "5 best hair oils and sustainably packaged conditioner bars",
      description: "Hair oils and sustainably packaged conditioner bars are big news in haircare, says Megan Douglas. She shares five products she’s coveting right now.",
      link: "https://womanmagazine.co.nz/5-best-hair-oils-and-sustainably-packaged-conditioner-bars/"
    },
    {
      title: "ADORE BEAUTY NZ",
      type: "BeautyIQ",
      description: "The Curly Hair Guide to the Best Products for Bouncy, Defined Locks",
      link: "https://www.adorebeauty.co.nz/beautyiq/hair/the-best-products-for-curly-hair/"
    },
  ];

  const handleReadMoreClick = (link) => {
    window.open(link, "_blank");
  };

  return (
    <Section id="blog" ref={element}>
      <Title value="Blog" />
      <div className="blogs">
        {blogsData.map(({ title, type, description, link }) => (
          <motion.div
            className="blog"
            variants={blogsAnimation}
            animate={controls}
            transition={{
              delay: 0.03,
              type: "tween",
              duration: 0.8,
            }}
            key={title}
          >
            <div className="image"></div>
            <div className="title">
              <h3>{title}</h3>
            </div>
            <span className="type">{type}</span>
            <div className="description">
              <p>{description}</p>
            </div>
            <div className="more" onClick={() => handleReadMoreClick(link)}>
              <img src={play} alt="Play" />
              <span>Read More</span>
            </div>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}

const Section = styled.section`
min-height: 100vh;
position: relative;
.blogs {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3rem;
  margin: 5rem 15rem;
  .blog {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    .image {
      height: 15rem;
      background: url(${home}) no-repeat center center;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .title {
      h3 {
        color: var(--secondary-color);
        font-size: 1.5rem;
      }
    }
    .type {
      color: var(--primary-color);
      font-weight: bolder;
      text-transform: uppercase;
    }
    .description {
      height: 10rem;
      color: var(--primary-color);
    }
    .more {
      display: flex;
      align-items: center;
      gap: 1rem;
      cursor: pointer;
      span {
        letter-spacing: 0.1rem;
        text-transform: uppercase;
        color: var(--primary-color);
      }
    }
  }
}
@media screen and (min-width: 280px) and (max-width: 1080px) { 
  margin: 2rem 0;
  .blogs {
    padding: 0 2rem;
    grid-template-columns: 1fr;
    margin: 0 1rem;
  }
}
`;

export default Blog